// export const baseUrl='https://application.amasi.org'; // Live Server
export const baseUrl='https://dev-application.amasi.org'; // Development Server
export const ROUTE_BASE_URL='/application';